// The quote is displayed with data: images but must be sent with the
// original cid: ones (createForward recopies the inline attachments server-side).
// Both versions hold the same images in the same order, which pairs them without
// the attachments themselves — their contentBytes are never populated.
const imageSources = (html: string): string[] =>
    Array.from(
        new DOMParser()
            .parseFromString(html, "text/html")
            .querySelectorAll("img"),
        (image) => image.getAttribute("src") ?? "",
    );

const IMAGE_TAG = /<img[^>]*?src\s*=\s*("([^"]*)"|'([^']*)')/gi;

const restoreCidImages = (
    editedHtml: string,
    previewHtml: string,
    sentHtml: string,
): string => {
    const displayed = imageSources(previewHtml);
    const original = imageSources(sentHtml);

    // Counts differ: the pairing by index can't be trusted, so leave the edit alone.
    if (displayed.length !== original.length) {
        return editedHtml;
    }

    const cidsBySource = new Map<string, string[]>();
    displayed.forEach((src, index) => {
        if (!src.startsWith("data:") || !original[index].startsWith("cid:")) {
            return;
        }
        const queue = cidsBySource.get(src) ?? [];
        queue.push(original[index]);
        cidsBySource.set(src, queue);
    });

    // Plain string substitution, never a DOM round-trip: re-serializing would
    // silently rewrite the quote.
    return editedHtml.replace(IMAGE_TAG, (tag, _quoted, doubled, singled) => {
        const src = doubled ?? singled ?? "";
        const cid = cidsBySource.get(src)?.shift();

        return cid === undefined ? tag : tag.replace(src, cid);
    });
};

export default restoreCidImages;
